// app/views/components/shared/StageBadge.tsx
import { Badge } from '@/components/ui/badge'

type Variant = 'formation' | 'service' | 'compliance' | 'license'

const STAGE_CONFIGS: Record<Variant, Record<string, { label: string; className: string }>> = {
  formation: {
    application: { label: 'Draft', className: 'bg-secondary text-secondary-foreground' },
    filing: { label: 'Filing', className: 'bg-blue-600 text-white' },
    completed: { label: 'Complete', className: 'bg-green-600 text-white' },
  },
  service: {
    application: { label: 'Application', className: 'bg-secondary text-secondary-foreground' },
    payment: { label: 'Paid', className: 'bg-yellow-600 text-white' },
    active: { label: 'Active', className: 'bg-green-600 text-white' },
    ended: { label: 'Ended', className: 'bg-gray-600 text-white' },
  },
  compliance: {
    application: { label: 'Draft', className: 'bg-secondary text-secondary-foreground' },
    payment: { label: 'Awaiting Payment', className: 'bg-orange-600 text-white' },
    filing: { label: 'Filing', className: 'bg-blue-600 text-white' },
    completed: { label: 'Complete', className: 'bg-green-600 text-white' },
  },
  license: {
    application: { label: 'Draft', className: 'bg-secondary text-secondary-foreground' },
    payment: { label: 'Awaiting Payment', className: 'bg-orange-600 text-white' },
    filing: { label: 'Filing', className: 'bg-blue-600 text-white' },
    completed: { label: 'Complete', className: 'bg-green-600 text-white' },
  },
}

type StageBadgeProps = {
  stage: string
  variant: Variant
}

export function StageBadge({ stage, variant }: StageBadgeProps) {
  const config = STAGE_CONFIGS[variant]
  const { label, className } = config[stage] || { label: stage, className: 'bg-secondary text-secondary-foreground' }
  return <Badge className={`font-normal text-xs ${className}`}>{label}</Badge>
}
